import { isConfigSet } from '@local/app-config';
import { useTrace } from '@local/web-design-system/utils';
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';

import {
    BENTLEY_SESSION_EXPIRED,
    LOGIN_ERROR_MESSAGES,
    NO_ACCESS,
    LOGIN_ALERT_SEVERITIES,
    LICENSE_GUARD_FAILURE,
    FIREWALL_GUARD_FAILURE,
} from '../../constants';
import { getLoginError } from '../../store/localStorageHelpers/loginErrorHelper';
import { ERROR_NOTIFICATION_MESSAGE } from '../../strings';

export function LoginError({
    helpSupportLink,
}: {
    /** If provided, overrides the support link used when a login error occurs. */
    helpSupportLink?: string;
}) {
    const loginError = getLoginError();
    const applyTrace = useTrace('login-error');

    // Custom login errors where we want to display a different alert.
    const customErrors = [
        NO_ACCESS,
        BENTLEY_SESSION_EXPIRED,
        LICENSE_GUARD_FAILURE,
        FIREWALL_GUARD_FAILURE,
    ];
    if (customErrors.includes(loginError)) {
        const errorMessage =
            LOGIN_ERROR_MESSAGES[loginError] ?? ERROR_NOTIFICATION_MESSAGE.preLinkedText;
        const severity = LOGIN_ALERT_SEVERITIES[loginError] ?? 'error';

        return (
            <Alert
                severity={severity}
                automation-id="login-error"
                sx={{
                    alignItems: 'center',
                }}
            >
                {errorMessage}
            </Alert>
        );
    }

    return loginError || !isConfigSet() ? (
        <Alert severity="error">
            <span {...applyTrace('message')}>
                {ERROR_NOTIFICATION_MESSAGE.preLinkedText}
                <Link
                    href={helpSupportLink ?? ERROR_NOTIFICATION_MESSAGE.href}
                    target="_blank"
                    color="inherit"
                    rel="noopener"
                    underline="always"
                >
                    {ERROR_NOTIFICATION_MESSAGE.linkedText}
                </Link>
            </span>
        </Alert>
    ) : null;
}
